<template>
    <main :class="[padding || 'py-10', margin || 'mb-8', 'bg-gray-50']">
        <slot></slot>
    </main>
    <AlertModal />
</template>

<script>
import AlertModal from '@par/alerts/AlertModal.vue';
export default {
    components: {
        AlertModal
    },
    props: ['padding', 'margin'],
    setup() {
        
    },
}
</script>